import { Pipe, PipeTransform } from '@angular/core';
import { OperationTypeMoveTypeEnum } from '@zaoblako/shared/modules/document/enums/operation.type.move.type.enum';

const operationTypeMoveTypeNames: Record<OperationTypeMoveTypeEnum, string> = {
  [OperationTypeMoveTypeEnum.DECREMENT]: 'Уменьшать',
  [OperationTypeMoveTypeEnum.EXCLUDE]: 'Не учитывать',
  [OperationTypeMoveTypeEnum.INCREMENT]: 'Увеличивать'
};

@Pipe({
  standalone: true,
  name: 'operationTypeMoveTypeName'
})
export class OperationTypeMoveTypeNamePipe implements PipeTransform {
  public transform(operationType: OperationTypeMoveTypeEnum): string {
    return operationTypeMoveTypeNames[operationType] || '';
  }
}
